//
//
//
//

export default {
  name: "radio-defaultValue-editor",
  props: {
    designer: Object,
    selectedWidget: Object,
    optionModel: Object
  }
};